
import { Component, Vue, Prop } from 'vue-property-decorator'
import { migrateOrder } from '@/api/order/index'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'migrate',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private infoList!: any[]
  @Prop({ required: true }) private ordernumbers!: any[]

  get language () {
    return AppModule.language
  }

  private setForm: any = {}
  private loading: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back () {
    this.setForm = {}
    this.$emit('close')
  }

  private async migrateOrder () {
    try {
      this.loading = true
      const data: any = {
        ordernumbers: this.ordernumbers,
        ...this.setForm
      }
      await migrateOrder(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message: 'migrate successfully!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '迁移成功!',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '遷移成功!',
            type: 'success'
          })
        }
        this.loading = false
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.loading = false
      this.flagStr()
    }
  }
}
